module.exports = __webpack_public_path__ + "static/media/EvergreenStormH2OPrimaryLogo.88cba928.jpg";